<template>
  <div class="dacu-goods">
    <!-- 筛选条件 -->
    <div class="query-section">
      <div class="form-row">
        <!-- 管理员推广位选择 -->
        <div class="form-group" v-if="isAdmin">
          <label>推广位选择：</label>
          <el-select v-model="selectedPositionId" @change="onPositionChange" placeholder="请选择推广位" clearable>
            <el-option v-for="position in positionOptions" :key="position.positionId"
              :label="`${position.positionId} ${position.positionName ? `(${position.positionName})` : '(---)'}`"
              :value="position.positionId" />
          </el-select>
        </div>

        <div class="form-group">
          <label>榜单选择：</label>
          <el-select v-model="queryForm.rankId" @change="onFilterChange" placeholder="请选择榜单" clearable>
            <el-option v-for="rank in rankOptions" :key="rank.value" :label="rank.label" :value="rank.value" />
          </el-select>
        </div>

        <div class="form-group">
          <label>排序类型：</label>
          <el-select v-model="queryForm.sortType" @change="onFilterChange" placeholder="请选择排序类型" clearable>
            <el-option v-for="sort in sortOptions" :key="sort.value" :label="sort.label" :value="sort.value" />
          </el-select>
        </div>

        <!-- <div class="form-group">
          <button @click="loadGoods(false)" :disabled="loading" style="width: 100%;margin: 0;">
            {{ loading ? '查询中...' : '查询商品' }}
          </button>
        </div> -->
      </div>
    </div>

    <!-- 商品列表 -->
    <div class="results-section" ref="resultsSection" @scroll="handleScroll" v-if="goodsData">
      <div class="goods-list">
        <div class="goods-card" v-for="goods in goodsData.data" :key="goods.itemId" style="cursor: pointer;">

          <div style="display: flex;">
            <!-- 左侧商品图片区域 -->
            <div class="goods-left">
              <div class="goods-image-container">
                <img :src="goods.imgList[0] || '/favicon.ico'" :alt="goods.skuName" @error="handleImageError"
                  class="goods-image" />

                <!-- 商品标签 -->
                <!-- <div class="image-tags" v-if="goods.skuTagList && goods.skuTagList.length > 0">
                  <span v-for="tag in goods.skuTagList.slice(0, 3)" :key="tag.name" 
                        :class="['image-tag', `tag-type-${tag.type}`]">
                    {{ tag.name }}
                  </span>
                </div> -->

                <!-- 优惠券标签 -->
                <div class="coupon-overlay"
                  v-if="goods.purchasePriceInfo?.couponList && goods.purchasePriceInfo.couponList.length > 0">
                  <span class="coupon-badge">有券</span>
                </div>
              </div>

              <!-- 价格标签 -->
              <!-- <div class="price-tags">
                <div class="main-price-tag">
                  <span class="price-label" style="color: #fff;width: 100%;text-align: center;">¥{{ formatPrice(goods.purchasePriceInfo?.purchasePrice || goods.wlprice) }}</span>
                  <span v-if="goods.wlprice && goods.purchasePriceInfo?.purchasePrice && goods.wlprice !== goods.purchasePriceInfo.purchasePrice" 
                        class="original-price">¥{{ formatPrice(goods.wlprice) }}</span>
                </div>
              </div> -->
            </div>

            <!-- 右侧商品信息区域 -->
            <div class="goods-right">
              <!-- 商品标题 -->
              <div class="goods-header">
                <h3 class="goods-title" :title="goods.skuName">{{ goods.skuName }}</h3>
              </div>

              <!-- 价格和佣金信息 -->
              <div class="price-commission-info">
                <div class="price-row">
                  <span class="price-label">到手价</span>
                  <div>
                    <span
                      v-if="goods.wlprice && goods.purchasePriceInfo?.purchasePrice && goods.wlprice !== goods.purchasePriceInfo.purchasePrice"
                      class="original-price">¥{{ formatPrice(goods.wlprice) }}</span>
                    <span class="price-value" style="margin-left: 6px;">¥{{
                      formatPrice(goods.purchasePriceInfo?.purchasePrice || goods.wlprice) }}</span>
                  </div>
                </div>
                <div class="commission-row">
                  <span class="commission-label">佣金({{ formatPercent(goods.commissionShare) }})</span>
                  <span class="commission-value">¥{{ formatPrice(goods.commission) }}</span>
                </div>
                <!-- <div class="subsidy-row" v-if="goods.commissionShare > 20">
                  <span class="subsidy-label">补贴({{ formatPercent(goods.commissionShare - 20) }})</span>
                  <span class="subsidy-value">¥{{ formatPrice(goods.commission * 0.8) }}</span>
                </div> -->
              </div>

              <!-- 评价信息 -->
              <div class="review-info" style="display: flex;align-items: center;justify-content: space-between;">
                <span class="good-review-rate" v-if="goods.goodCommentsShare">
                  好评率 {{ goods.goodCommentsShare }}%
                </span>
                <span @click.stop="shareGoods(goods)"
                  style="background: #42b983;color: white;padding: 2px 4px;border-radius: 4px;font-size: 12px;font-weight: 500;cursor: pointer;transition: all 0.2s;">
                  <i class="icon-share"></i>分享赚 {{ formatPrice(goods.commission) }}
                </span>
              </div>


            </div>



          </div>

          <!-- 优惠券信息 -->
          <!-- <div class="coupon-info" style="display: flex;gap: 6px;margin: 6px;" v-if="goods.purchasePriceInfo?.couponList && goods.purchasePriceInfo.couponList.length > 0">
            <div class="coupon-item" v-for="coupon in goods.purchasePriceInfo.couponList" :key="coupon.link">
              <span class="coupon-amount">满{{ coupon.quota }}减去{{ coupon.discount }}</span>
            </div>
          </div> -->
          <!-- 操作按钮 -->
          <!-- <div class="goods-actions">
              <button @click="downloadImage(goods)" class="action-btn download-btn">
                <i class="icon-download"></i>
                下载图片
              </button>
              <button @click="shareGoods(goods)" class="action-btn share-btn">
                <i class="icon-share"></i>
                分享赚 {{ formatPrice(goods.commission) }}
              </button>
          </div> -->
        </div>
      </div>

      <!-- 加载更多状态 -->
      <div v-if="loadingMore" class="loading-more">
        <div class="loading-spinner"></div>
        <p>正在加载更多...</p>
      </div>

      <!-- 没有更多数据提示 -->
      <div
        v-if="goodsData && goodsData.data && goodsData.data.length >= goodsData.totalCount && goodsData.data.length > 0"
        class="no-more-data">
        <p>已加载全部</p>
      </div>

    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading">
      <div class="loading-spinner"></div>
      <p>正在加载...</p>
    </div>

    <!-- 错误状态 -->
    <div v-if="error" class="error">
      <p>{{ error }}</p>
      <button @click="loadGoods" class="retry-btn">重试</button>
    </div>

    <!-- 回到顶部按钮 -->
    <div v-if="showBackToTop" class="back-to-top" @click="scrollToTop">
      <i class="el-icon-top"></i>
    </div>

    <!-- 分享赚钱弹窗 -->
    <ShareEarnModalEasy :visible="showShareModal" :goods="selectedGoods" :positionId="currentPositionId"
      @close="closeShareModal" @share-earn="handleShareEarn" />
  </div>
</template>

<script>
import { queryRankGoods, getAllPositions } from '@/utils/jdApi'
import ShareEarnModalEasy from '@/components/ShareEarnModalEasy.vue'

export default {
  name: 'GoodsList',
  components: {
    ShareEarnModalEasy
  },
  data() {
    return {
      loading: false,
      loadingMore: false,
      error: null,
      goodsData: null,
      allGoods: [], // 存储所有商品数据
      showBackToTop: false, // 控制回到顶部按钮显示
      showShareModal: false, // 控制分享弹窗显示
      selectedGoods: null, // 选中的商品信息
      selectedPositionId: null, // 管理员选择的推广位ID
      positionOptions: [], // 推广位选项列表
      currentSiteId: '', // 当前使用的媒体ID，默认值作为兜底
      currentSceneId: 1, // 当前使用的场景ID，默认值作为兜底
      queryForm: {
        rankId: 200000, // 默认全部榜单
        sortType: 2, // 默认高佣排序
        pageIndex: 1, // 页码
        pageSize: 10 // 每页数量
      },
      rankOptions: [
        { label: '全部', value: 200000 },
        { label: '食品酒水', value: 200001 },
        { label: '家庭清洁', value: 200002 },
        { label: '个护美妆', value: 200003 },
        { label: '医药保健', value: 200004 },
        { label: '生鲜', value: 200005 },
        { label: '数码家电', value: 200006 },
        { label: '家居日用', value: 200007 },
        { label: '时尚生活', value: 200008 }
      ],
      sortOptions: [
        { label: '2小时', value: 1 },
        { label: '高佣', value: 2 },
        { label: '24小时', value: 3 }
      ]
    }
  },
  computed: {
    // 检查是否为管理员
    isAdmin() {
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      return user.role === 'ADMIN'
    },

    // 当前使用的推广位ID
    currentPositionId() {
      if (this.isAdmin) {
        return this.selectedPositionId
      } else {
        const user = JSON.parse(localStorage.getItem('user') || '{}')
        return user.positionId
      }
    }
  },
  mounted() {
    this.loadGoods()
    this.setupScrollListener()
    // 如果是管理员，加载推广位列表
    if (this.isAdmin) {
      this.loadPositionOptions()
    }
  },
  beforeDestroy() {
    this.removeScrollListener()
  },
  methods: {
    async loadGoods(isLoadMore = false) {
      if (isLoadMore) {
        this.loadingMore = true
      } else {
        this.loading = true
        this.queryForm.pageIndex = 1 // 重置页码
        this.allGoods = [] // 清空之前的数据
        this.goodsData = null // 清空商品数据
      }
      this.error = null

      try {
        const response = await queryRankGoods(this.queryForm)

        // 处理新的响应结构：使用完整的API数据
        if (response && response.code === 200) {

          // 获取完整的原始数据
          const rawData = response.rawData || {}
          const goodsList = response.data || []

          if (isLoadMore) {
            // 检查是否有重复数据
            const existingIds = new Set(this.allGoods.map(item => item.itemId))
            const newData = goodsList.filter(item => !existingIds.has(item.itemId))

            this.allGoods = [...this.allGoods, ...newData]
          } else {
            // 首次加载或重新查询：替换数据
            this.allGoods = goodsList
          }

          // 更新goodsData，包含完整的原始数据供前端使用
          this.goodsData = {
            code: 200,
            data: this.allGoods,
            message: response.message || '查询成功',
            totalCount: response.totalCount || 0,
            pageIndex: response.pageIndex || 1,
            pageSize: response.pageSize || 10,
            // 保存完整的原始API数据，供前端挑选使用
            rawData: rawData
          }
        } else {
          this.error = '查询失败'
          console.error('API调用失败:', response)
        }
      } catch (error) {
        this.error = '查询失败'
        console.error('网络错误:', error)
      } finally {
        this.loading = false
        this.loadingMore = false
      }
    },

    // 筛选条件变化处理
    onFilterChange() {
      // 重置分页和数据
      this.queryForm.pageIndex = 1
      this.allGoods = []
      this.goodsData = null
      // 重新加载数据
      this.loadGoods()
    },

    // 设置滚动监听（保留方法，但实际通过模板的 @scroll 事件绑定）
    setupScrollListener() {
      // 现在通过模板的 @scroll 事件绑定，此方法保留为空或用于其他逻辑
    },

    // 移除滚动监听（保留方法，但实际通过模板的 @scroll 事件绑定）
    removeScrollListener() {
      // 现在通过模板的 @scroll 事件绑定，此方法保留为空或用于其他逻辑
    },

    // 处理滚动事件
    handleScroll(event) {
      const scrollContainer = event.target || this.$refs.resultsSection
      if (!scrollContainer) return

      const scrollTop = scrollContainer.scrollTop
      const scrollHeight = scrollContainer.scrollHeight
      const clientHeight = scrollContainer.clientHeight

      // 控制回到顶部按钮显示（滚动超过300px时显示）
      this.showBackToTop = scrollTop > 300

      // 距离底部100px时开始加载
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.loadMoreGoods()
      }
    },

    // 加载更多商品
    async loadMoreGoods() {
      // 防止重复加载
      if (this.loadingMore || this.loading) return

      // 检查是否还有更多数据
      if (this.goodsData && this.goodsData.data && this.goodsData.data.length >= this.goodsData.totalCount) {
        return // 没有更多数据了
      }
      this.queryForm.pageIndex++
      await this.loadGoods(true)
    },

    // 回到顶部
    scrollToTop() {
      const scrollContainer = this.$refs.resultsSection
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },

    handleImageError(event) {
      event.target.src = '/favicon.ico'
    },

    formatPrice(price) {
      if (!price) return '0.00'
      return Number(price).toFixed(2)
    },

    formatPercent(percent) {
      if (!percent) return '0%'
      return Number(percent).toFixed(1) + '%'
    },

    copyGoodsLink(url) {
      if (!url) return

      try {
        navigator.clipboard.writeText(url)
        this.$message?.success?.('链接已复制到剪贴板')
      } catch (e) {
        // 降级方案
        const input = document.createElement('input')
        input.value = url
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message?.success?.('链接已复制到剪贴板')
      }
    },

    openGoodsLink(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },

    downloadImage(goods) {
      // 下载商品图片
      const link = document.createElement('a')
      link.href = goods.imageUrl
      link.download = `${goods.skuName}.jpg`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    shareGoods(goods) {
      // 显示分享赚钱弹窗
      this.selectedGoods = goods
      this.showShareModal = true
    },

    // 打开商品详情
    openDetail(goods) {
      const detailData = {
        ...goods,
        promotionParams: {
          positionId: this.currentPositionId, // 当前选择的推广位ID
        }
      }
      sessionStorage.setItem('productDetail', JSON.stringify(detailData))
      this.$router.push({ path: '/product-detail', query: { id: goods.itemId } })
    },

    // 关闭分享弹窗
    closeShareModal() {
      this.showShareModal = false
      this.selectedGoods = null
    },

    // 处理分享赚钱
    handleShareEarn(shareData) {
      // 使用完整的商品数据生成分享内容
      const shareText = this.generateShareText(shareData)

      if (navigator.share) {
        navigator.share({
          title: shareData.title,
          text: shareText,
          url: shareData.itemId
        }).then(() => {
          this.$message?.success?.('分享成功')
        }).catch(() => {
          // 降级方案：复制到剪贴板
          this.copyGoodsLink(shareText)
        })
      } else {
        // 降级方案：复制到剪贴板
        this.copyGoodsLink(shareText)
      }
    },

    // 生成分享文案
    generateShareText(shareData) {
      let shareText = `🔥 推荐商品：${shareData.title}\n`
      shareText += `💰 导购价：¥${this.formatPrice(shareData.price)}\n`

      if (shareData.originalPrice && shareData.originalPrice !== shareData.price) {
        shareText += `💸 原价：¥${this.formatPrice(shareData.originalPrice)}\n`
      }

      shareText += `🎯 佣金：¥${this.formatPrice(shareData.commission)} (${this.formatPercent(shareData.commissionShare)})\n`

      if (shareData.shopName) {
        shareText += `🏪 店铺：${shareData.shopName}\n`
      }

      if (shareData.goodCommentsShare) {
        shareText += `⭐ 好评率：${shareData.goodCommentsShare}%\n`
      }

      if (shareData.brand?.brandName) {
        shareText += `🏷️ 品牌：${shareData.brand.brandName}\n`
      }

      if (shareData.category?.cid3Name) {
        shareText += `📦 分类：${shareData.category.cid3Name}\n`
      }

      // 添加推广链接信息
      if (shareData.promotion?.link) {
        shareText += `🔗 购买链接：${shareData.promotion.link}\n`
      }

      if (shareData.promotion?.positionId) {
        shareText += `📍 推广位：${shareData.promotion.positionId}\n`
      }

      shareText += `🆔 商品ID：${shareData.itemId}`

      return shareText
    },

    // 加载推广位选项（管理员使用）
    async loadPositionOptions() {
      try {
        const response = await getAllPositions()
        if (response && response.success && response.data) {
          this.positionOptions = response.data
          // 默认选择第一个推广位
          if (this.positionOptions.length > 0) {
            this.selectedPositionId = this.positionOptions[0].positionId
          }
        } else {
          this.$message.error('加载推广位列表失败')
        }
      } catch (error) {
        this.$message.error('加载推广位列表失败')
      }
    },

    // 推广位选择变化处理
    onPositionChange() {
      // 推广位变化时不需要重新加载商品，只需要更新当前选择的推广位
    },
  }
}
</script>

<style scoped>
.dacu-goods {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
}

.query-section,
.results-section {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
}

.results-section {
  flex: 1;
  overflow-y: auto;
}

.form-group {
  display: flex;
  align-items: center;
  width: 100%;
}

.form-group label {
  display: inline-block;
  width: 100px;
  font-weight: bold;
  white-space: nowrap;
}

.form-group input,
.form-group select {
  width: 200px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 10px;
}

button {
  background: #42b983;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.stats {
  background: #e8f5e8;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.stats p {
  margin: 5px 0;
  font-weight: bold;
}

.goods-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* margin-bottom: 30px; */
}

.goods-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  min-height: 120px;
  transition: box-shadow 0.2s;
}

.goods-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

/* 左侧商品图片区域 */
.goods-left {
  flex: 0 0 120px;
  position: relative;
  background: #f8f9fa;
}

.goods-image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.goods-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-tags {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.image-tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: white;
}

.tag-type-4 {
  background: #ff6b35;
}

/* 超万人种草 */
.tag-type-5 {
  background: #28a745;
}

/* 京喜 */
.tag-type-8 {
  background: #fd7e14;
}

/* 超级补贴 */
.tag-type-12 {
  background: #17a2b8;
}

/* 7天无理由退货 */
.tag-type-14 {
  background: #6f42c1;
}

/* 同款高转化 */

.coupon-overlay {
  position: absolute;
  top: 0px;
  right: 0px;
}

.coupon-badge {
  background: #dc3545;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.price-tags {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  width: 100px;
}

.main-price-tag {
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-label {
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.original-price {
  color: #ccc;
  font-size: 14px;
  text-decoration: line-through;
}

/* 右侧商品信息区域 */
.goods-right {
  flex: 1;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.goods-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}


.price-row,
.commission-row,
.subsidy-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price-label,
.commission-label,
.subsidy-label {
  font-size: 14px;
  color: #6c757d;
}

.price-value,
.commission-value,
.subsidy-value {
  font-size: 16px;
  font-weight: 600;
  color: #ff6b35;
}

.review-info {
  font-size: 12px;
  color: #6c757d;
}

.review-count,
.good-review-rate {
  margin-right: 12px;
}


.coupon-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 12px;
}

.coupon-amount {
  color: #856404;
  font-weight: 500;
}

.coupon-condition {
  color: #856404;
}

.goods-actions {
  display: flex;
  gap: 8px;
  margin-top: auto;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 8px;
}

.download-btn {
  background: #42b983;
  color: white;
}

.download-btn:hover {
  background: #369870;
}

.share-btn {
  background: #42b983;
  color: white;
}

.share-btn:hover {
  background: #369870;
}

.icon-download,
.icon-share {
  width: 12px;
  height: 12px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .dacu-goods {
    padding: 10px;
  }

  .query-section,
  .results-section {
    padding: 10px;
  }

  .form-group label {
    width: auto;
    display: block;
  }

  .form-group input,
  .form-group select {
    width: 100%;
    box-sizing: border-box;
  }

  .form-row {
    flex-direction: column;
  }

  .goods-card {
    flex-direction: column;
    min-height: auto;
  }

  .goods-left {
    width: 120px;
    height: 120px;
  }


  .goods-actions {
    flex-direction: row;
    gap: 8px;
  }

  .action-btn {
    width: 100%;
    justify-content: center;
    margin-right: 0;
  }
}

.goods-image {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.goods-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.goods-card:hover .goods-image img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 8px;
  right: 8px;
}

.coupon-tag {
  background: #ff4757;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.goods-info {
  padding: 16px;
}

.goods-title {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.4;
  height: 2.8em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.price-info {
  margin-bottom: 12px;
}

.price-main {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.current-price {
  font-size: 18px;
  font-weight: 600;
  color: #e74c3c;
}

.original-price {
  font-size: 14px;
  color: #ccc;
  text-decoration: line-through;
}

.commission-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #7f8c8d;
}

.commission-rate {
  color: #27ae60;
  font-weight: 500;
}

.commission-amount {
  color: #e67e22;
  font-weight: 500;
}

.shop-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 12px;
}

.shop-name {
  color: #34495e;
  font-weight: 500;
}

.shop-level {
  color: #f39c12;
  display: flex;
  align-items: center;
  gap: 2px;
}

.star {
  font-size: 10px;
}


.coupon-item {
  display: inline-block;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 11px;
}

.coupon-amount {
  color: #e17055;
  font-weight: 600;
}

.coupon-condition {
  color: #6c757d;
  margin-left: 4px;
}

.goods-tags {
  margin-bottom: 12px;
}

.tag {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  margin-right: 4px;
  margin-bottom: 4px;
}

.tag-return {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.goods-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  flex: 1;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.copy-btn {
  background: #6c757d;
  color: white;
}

.copy-btn:hover {
  background: #5a6268;
}

.view-btn {
  background: #007bff;
  color: white;
}

.view-btn:hover {
  background: #0056b3;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 30px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background: white;
  color: #495057;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.page-btn:hover:not(:disabled) {
  background: #e9ecef;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  color: #6c757d;
  font-size: 14px;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #6c757d;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.error {
  text-align: center;
  padding: 40px;
  color: #dc3545;
}

.retry-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 16px;
}

.retry-btn:hover {
  background: #c82333;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .dacu-goods {
    padding: 10px;
  }

  .filter-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-group {
    width: 100%;
  }

  .filter-group select {
    width: 100%;
  }

  .goods-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .goods-actions {
    flex-direction: row;
  }

  .action-btn {
    width: 100%;
  }
}

/* 加载更多样式 */
.loading-more {
  text-align: center;
  padding: 20px;
  color: #6c757d;
}

.loading-more .loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}

.no-more-data {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
}

.no-more-data p {
  margin: 0;
}

/* 回到顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 60px;
  right: 14px;
  width: 35px;
  height: 35px;
  background: #42b983;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
  transition: all 0.3s ease;
  z-index: 1000;
}

.back-to-top:hover {
  background: #369870;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(66, 185, 131, 0.4);
}

.back-to-top:active {
  transform: translateY(0);
}

/* 移动端适配 */
@media (max-width: 768px) {

  .back-to-top svg {
    width: 20px;
    height: 20px;
  }
}
</style>
